/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.RadioGroup = (function () {

    function RadioGroup () {

        Monet.UI.Fields.Base.apply(this, arguments);

        this.createBaseStructure();
        var __radioButtons = [];
        var __fieldDomains = [];

        __radioButtons.radioAlreadyExists = function (value) {

            var exists = false;

            for (var i = 0; i < __radioButtons.length; i++) {

                var radioButton = __radioButtons[i];

                if (radioButton.input && radioButton.input.value === value) {
                    exists = true;
                    break;
                }

            }

            return exists;

        };
        
        this.setId = function (id) {
            this.id = id;
        };
    
        this.getId = function () {
            return this.id;
        };

        this.clear = function() {
            if(__radioButtons && __radioButtons.length) {
                for( var i=0, length = __radioButtons.length; i < length; i++ ) {
                    __radioButtons[i].setChecked(false);
                }
            }
        };

        this.enable = function () {
            this.disabled = false;
            __radioButtons.forEach(radioButton => {
                radioButton.enable();
            });
        };

        this.disable = function () {
            this.disabled = true;
            __radioButtons.forEach(radioButton => {
                radioButton.disable();
            });
        };

        this.setFieldDomains = function (fieldDomains){
            __fieldDomains = fieldDomains;
            var radioButtons = [];
            for(var i = 0, length = __fieldDomains.length; i < length; i++){
              var fieldDomain = __fieldDomains[i];
                radioButtons.push({
                  type: 'RADIO',
                  name: 'RadioItem_' + this.id,
                  value: fieldDomain.value,
                  id: fieldDomain.id,
                  label: fieldDomain.description
              });
            }

            this.setRadioButtons(radioButtons);
        };

        this.setRadioButtons = function (radioButtons) {

            var radiosLength = radioButtons.length;

            if (radioButtons) {

                for (var j = 0; j < radiosLength; j++) {

                    var value = radioButtons[j].value;

                    if (!__radioButtons.radioAlreadyExists(value)) {

                        var render = new Monet.UI.Fields.Render(radioButtons[j], this.entity);
                        var radio = render.render();
                        radio.setChecked(false);
                        if (radioButtons[j].id) {
                            radio.setInputId(radioButtons[j].id);
                        }
                        radio.rootEl.className = "radio_group_item";
                        __radioButtons.push(radio);

                    }

                }

            }

        };

        this.setSelected = function (selected) {

            var radioButtonsLength = __radioButtons.length;

            for (var k = 0; k < radioButtonsLength; k++) {
                var radio = __radioButtons[k];
                if(radio.input.value === selected){
                    radio.setChecked(true);
                    this.afterSelectValue && this.afterSelectValue();
                    break;
                }
            }
        };

        this.setValue = function (selected) {
            this.setSelected(selected);
        };


        this.getValue = function (){
            var option = this.getOptionSelected();
            if(option){
                return option.getValue();
            }
            return null;
        };

        this.getRadioButton = function (value) {
            var radioButtonsLength = __radioButtons.length;

            for (var k = 0; k < radioButtonsLength; k++) {
                var radio = __radioButtons[k];
                if(radio.input.value === value){
                    return radio;
                }
            }
            return null;
        };

        this.getRadioButtons = function () {

            return __radioButtons;

        };

        this.createOptionsGroup = function () {

            var radioButtonsLength = __radioButtons.length;

            for (var k = 0; k < radioButtonsLength; k++) {

                var radio = __radioButtons[k];
                this.rootEl.appendChild(radio.rootEl);

            }

        };

        this.getOptionSelected = function () {

            var radioButtonsLength = __radioButtons.length;
            var optionSelected = null;

            for (var k = 0; k < radioButtonsLength; k++) {

                var radio = __radioButtons[k];

                if (radio.input.checked) {
                    optionSelected = radio;
                    break;
                }

            }

            return optionSelected;

        };

        this.setDefaultValue = function (defaultValue){

            this.setSelected(defaultValue);

        };

        this.render = function () {

            this.createOptionsGroup();

            this.label.className += 'optionGroup-label';
            this.rootEl.className = 'optionGroup';

            return this.rootEl;

        };

    }

    return RadioGroup;

}());